export default "__VITE_ASSET__CxZMRi4x__"